import { requestWithToken } from '../../utilities/request';
import SessionStorageService from '../../services/utilities/SessionStorageService';
const path = '/api/private/fields';

/**
 * 入退場実績一覧取得API
 * @param {string}fieldId: 現場ID
 * @param {object}param
 * */
const fetchInOutResultList = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/check_in_out_logs/list`),
    params: param,
  });
};

/**
 * 入退場実績CSV出力API
 * @param {string}fieldId: 現場ID
 * @param {object}param
 * */
const fetchInOutCSV = (fieldId, param) => {
  const token = SessionStorageService.getToken();
  const apiPath = path.concat(`/${fieldId}/check_in_out_logs/list.csv`);
  param.csv_token = token;
  return requestWithToken({
    method: 'GET',
    url: apiPath,
    params: param,
    responseEncoding: 'shift-jis',
    responseType: 'blob',
  });
};

/**
 * 入退場実績登録API
 * @param {string}fieldId: 現場ID
 * @param {object}data
 * */
const registerInOutResult = (fieldId, data) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/check_in_out_logs/`),
    data,
  });
};

/**
 * 入退場実績更新API
 * @param {string}fieldId: 現場ID
 * @param {string}checkInOutLogId: 入退場実績ID
 * @param {object}data
 * */
const updateInOutResult = (fieldId, checkInOutLogId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/check_in_out_logs/${checkInOutLogId}`),
    data,
  });
};

/**
 * 入退場実績削除API
 * @param {string}fieldId: 現場ID
 * @param {object}data
 * */
const deleteInOutResult = (fieldId, data) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`/${fieldId}/check_in_out_logs/destroy_list`),
    data,
  });
};

/**
 * 入退場実績全承認API
 * @param {string}fieldId: 現場ID
 * */
const updateInOutResultAllApprove = fieldId => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/check_in_out_logs/all_approve`),
  });
};

/**
 * 入退場実績承認API
 * @param {string}fieldId: 現場ID
 * @param {object}data
 * */
const updateInOutResultApprove = (fieldId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/check_in_out_logs/approve`),
    data,
  });
};

/**
 * 入退場実績承認解除API
 * @param {string}fieldId: 現場ID
 * @param {object}data
 * */
const updateInOutResultUnapproved = (fieldId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/check_in_out_logs/cancel_approve`),
    data,
  });
};

/**
 * 作業員の紐づく協力会社現場ツリー情報取得API
 * @param {string}fieldId: 現場ID
 * @param {string}workerId: 作業員ID
 * @param {object}param
 * */
const fetchAssignedFieldTreeWorkersList = (fieldId, workerId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/${fieldId}/workers/${workerId}/assigned_field_tree_workers`
    ),
    params: param,
  });
};

/**
 * 施工体系作業員の紐づく協力会社現場ツリー情報取得API
 * @param {string}fieldId: 現場ID
 * @param {string}workerId: 作業員ID
 * @param {string}fieldTreeWorkerId: 施工体系作業員ID
 * */
const fetchAssignedFieldTreeWorker = (fieldId, workerId, fieldTreeWorkerId) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/${fieldId}/workers/${workerId}/assigned_field_tree_worker/${fieldTreeWorkerId}`
    ),
  });
};

/**
 * @param {string}fieldId: 現場ID
 * */
const fetchMainJvSecededCcus = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/main_jv_ccus_seceded_warning`),
  });
};

export const InOutResultApi = {
  fetchInOutResultList,
  fetchInOutCSV,
  registerInOutResult,
  updateInOutResult,
  deleteInOutResult,
  updateInOutResultAllApprove,
  updateInOutResultApprove,
  updateInOutResultUnapproved,
  fetchAssignedFieldTreeWorkersList,
  fetchAssignedFieldTreeWorker,
  fetchMainJvSecededCcus,
};

export default InOutResultApi;



// WEBPACK FOOTER //
// ./src/services/inOutResult/InOutResultApi.js